import { t, plural } from "@lingui/macro";
import { Message } from "../../models/Message";
import { Notification, NotificationType } from "../../models/Notification";
import { Util } from "./Util";
import { UtilApp } from "./UtilApp";


//notification
export class NotificationUtil {

  static createForMessage(msg: Message, toUserId: string): Notification {
    let type: NotificationType = 'Info';
    if (msg.recording) {
      type = 'Voice';
    } else if (msg.videoUrl) {
      type = 'VideoRecording';
    } else if (msg.emoticon) {
      type = 'Emoticon';
    } else if (!!msg.files?.find(f => f.group == 'image')) {
      type = 'Images';
    } else if (!!msg.files?.find(f => f.group == 'doc')) {
      type = 'Docs';
    } else if (msg.text) {
      type = 'Text';
    } else if (msg.emoji) {
      type = 'Emoji';
    }
    return new Notification(type, toUserId, msg.roomId, null, msg.id, msg.parentMessageId, msg.replyToMessageId, msg.user);
  }

  /** 캘린더 리마인더 제목 = 시작까지 남은 시간 표현 (구글 캘린더 방식). minutes: 0=지금 시작 */
  static reminderLeadText(minutes?: number): string {
    if (!minutes || minutes <= 0) return t`Starting now`;
    if (minutes % 1440 === 0) {
      const n = minutes / 1440;
      return plural(n, { one: 'In # day', other: 'In # days' });
    }
    if (minutes % 60 === 0) {
      const n = minutes / 60;
      return plural(n, { one: 'In # hour', other: 'In # hours' });
    }
    return plural(minutes, { one: 'In # minute', other: 'In # minutes' });
  }

  static getSummaryTranslated(notif: Notification): string {
    const mentionEnding = ' ' + (notif.isMentioned ? t`and mentioned you` : '');
    if (notif.type == 'Voice') {
      return t`${notif.fromUser?.name} recorded a new message`;
    } else if (notif.type == 'Text') {
      if (notif.subtitle)
        return notif.subtitle;
      else
        return notif.isMentioned ? t`${notif.fromUser?.name} mentioned you` : t`${notif.fromUser?.name} wrote a message`;
    } else if (notif.type == 'VideoRecording') {
      return t`${notif.fromUser?.name} posted a video` + mentionEnding;
    } else if (notif.type == 'Emoticon') {
      return t`${notif.fromUser?.name} left a reaction`;
    } else if (notif.type == 'Emoji') {
      return t`${notif.fromUser?.name} left an emoji`;
    } else if (notif.type == 'Images') {
      return t`${notif.fromUser?.name} shared images` + mentionEnding;
    } else if (notif.type == 'Docs') {
      return t`${notif.fromUser?.name} shared documents` + mentionEnding;
    } else if (notif.type == 'RoomAdded') {
      return t`${notif.fromUser?.name} added you to ${notif.roomName}`;
    } else if (notif.type == 'CallStart') {
      if (Util.isOneToOneRoom(notif.roomName)) {
        return t`${notif.fromUser?.name} requested a voice call`;
      } else {
        return t`${notif.fromUser?.name} started a call in ${notif.roomName}`;
      }
    } else if (notif.type == 'BoardPost') {
      // 본문 = 내용(게시글 타이틀 / 댓글 내용)만. 작성자·채널·게시판명은 제목줄에 모아 표시.
      return notif.subtitle ?? '';
    } else if (notif.type == 'CalendarEvent') {
      // 구글 방식: 본문 = 이벤트 제목(roomName). 제목(시간 표현)은 NotificationModal 제목줄에서 reminderLeadText 로.
      return notif.roomName || t`Event`;
    } else {
      return t`${notif.fromUser?.name} posted something` + mentionEnding;
    }
  }

}
